<template>
  <v-layout justify-center>
    <v-flex xs12 sm6 class="mt-2">
      <v-toolbar color="white" dark>
        <v-toolbar-title class="red--text">Subscription Plans</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          small
          dark
          class="no-uppercase red--text"
          @click="back"
        >
          back
        </v-btn>
      </v-toolbar>
      <template>
        <v-card flat v-if="indexData.packages">
          <!-- <v-card-text>{{ text }}</v-card-text> -->
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <div v-if="indexData.packages">
                  <v-data-table
                    :headers="urlHeaders"
                    :items="serviceData()"
                    item-key="id"
                    class="elevation-1"
                    hide-actions
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-left">{{ props.item.name }}</td>

                      <td class="text-xs-left" v-if="hasLimit(props.item.id)">
                        <span v-if="hasPrivilege(1, props.item.id)">{{
                          hasPrivilege(1, props.item.id).max_limit
                        }}</span>
                        <v-icon
                          class="material-symbols-outlined"
                          color="red"
                          v-else
                          >cancel</v-icon
                        >
                      </td>
                      <td class="text-xs-left" v-else>
                        <v-icon
                          class="material-symbols-outlined"
                          color="green"
                          v-if="hasAllowedPrivilege(1, props.item.id)"
                          >check_circle</v-icon
                        >
                        <v-icon
                          class="material-symbols-outlined"
                          color="red"
                          v-else
                          >cancel</v-icon
                        >
                      </td>
                      <td class="text-xs-left" v-if="hasLimit(props.item.id)">
                        <span v-if="hasPrivilege(2, props.item.id)">{{
                          hasPrivilege(2, props.item.id).max_limit
                        }}</span>
                        <v-icon
                          class="material-symbols-outlined"
                          color="red"
                          v-else
                          >cancel</v-icon
                        >
                      </td>
                      <td class="text-xs-left" v-else>
                        <v-icon
                          class="material-symbols-outlined"
                          color="green"
                          v-if="hasAllowedPrivilege(2, props.item.id)"
                          >check_circle</v-icon
                        >
                        <v-icon
                          class="material-symbols-outlined"
                          color="red"
                          v-else
                          >cancel</v-icon
                        >
                        
                      </td>
                      <td class="text-xs-left" v-if="hasLimit(props.item.id)">
                        <span v-if="hasPrivilege(3, props.item.id)">{{
                          hasPrivilege(3, props.item.id).max_limit
                        }}</span>
                        <v-icon
                          class="material-symbols-outlined"
                          color="red"
                          v-else
                          >cancel</v-icon
                        >
                      </td>
                      <td class="text-xs-left" v-else>
                        <v-icon
                          class="material-symbols-outlined"
                          color="green"
                          v-if="hasAllowedPrivilege(3, props.item.id)"
                          >check_circle</v-icon
                        >
                        <v-icon
                          class="material-symbols-outlined"
                          color="red"
                          v-else
                          >cancel</v-icon
                        >
                      </td>
                    </template>
                  </v-data-table>
                  <v-layout row v-if="indexData.assignPackageServices">
                    <v-btn color="blue darken-1" flat @click="close"
                      >Cancel</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
                  </v-layout>
                </div>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="white darken-1"
                small
                dark
                class="no-uppercase red--text"
                @click="back"
              >
                back
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/router";
export default {
  data: () => ({
    urlHeaders: [
      {
        text: "Service Name",
        align: "left",
        value: "name",
        sortable: false,
      },
      {
        text: "Basic",
        align: "left",
        value: "id",
        sortable: false,
      },
      {
        text: "Premium",
        align: "left",
        value: "id",
        sortable: false,
      },
      {
        text: "Corporate",
        align: "left",
        value: "id",
        sortable: false,
      },
    ],
    max_array: [1, 2, 4, 6, 7, 19, 20, 21, 22],
  }),
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    loadData() {
      if (this.indexData.packages) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    serviceData() {
      if (this.indexData.services) {
        return this.indexData.services.data;
      }
      return false;
    },
  },
  created() {
    this.initialize();
  },

  methods: {
    back() {
      router.push("/subscription-package");
    },
    initialize() {
      this.$store.dispatch("setIndexData", ["package-comparison"]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    hasLimit(serviceId) {
      return this.max_array.includes(serviceId);
    },

    hasPrivilege(packageId, serviceId) {
      return this.indexData.packages.data[packageId - 1].package_detail.find(
        (element) => element.service_id === serviceId
      );
    },
    serviceData() {
      if (this.indexData.services) {
        return this.indexData.services.data;
      }
    },
    hasAllowedPrivilege(packageId, serviceId) {
      return this.indexData.packages.data[packageId - 1].package_detail.find(
        (element) => element.service_id === serviceId
      );

      // console.log(result);
      // return true;
    },
    save() {
      // console.log(this.editedItem.selected)
      // console.log(this.indexData.assignedUrlsToRole)
      if (this.editedIndex > -1) {
        this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
      } else {
        this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
      }
      this.snackbar = true;
      this.close();
    },
  },
};
</script>
